module.exports = __webpack_public_path__ + "img/test.8f432e36.png";